import styled from "styled-components";

const CardContainer = styled.div<{
  isSelected: boolean;
  isComingSoon: boolean;
}>`
  border: ${(props) => (props.isSelected ? "1px solid #08004c" : "none")};
  border-radius: 10px;
  cursor: ${(props) => (props.isComingSoon ? "not-allowed" : "pointer")};
  background: #ffffff;
  width: 90%;
`;

const CardHeader = styled.div`
  display: flex;
  background-color: #f7f7f7;
  /* padding-left: 15px; */
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  @media only screen and (max-width: 768px) {
    padding: 0;
  }
`;

const CardTitle = styled.h4`
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #0e0e0e;
  padding-left: 13px;
`;

const GreenText = styled.span`
  color: #00a603; // Green color
  padding-left: 5px;
`;

const CardDes = styled.p`
  width: 95%;
  margin: 0 auto;
  padding-top: 15px;
  padding-bottom: 25px;
  font-size: 14px;
  font-weight: 400;
  color: #5e5e5e;
  line-height: 24px;
`;

const CardButton = styled.button<{ isComingSoon: boolean }>`
  width: 100%;
  height: 44px;
  background-color: #f7f7f7;
  align-items: center;
  border: none;
  border-radius: 10px;
  font-weight: 500;
  font-size: 14px;
  font-family: GT Walsheim Pro;
  color: ${(props) => (props.isComingSoon ? "#808080" : "#0e0e0e")};
  cursor: ${(props) => (props.isComingSoon ? "not-allowed" : "pointer")};
`;

const CardButtonCon = styled.div`
  width: 90%;
  display: flex;
  margin: 0 auto;
  padding-bottom: 20px;
`;

type CardsProps = {
  cards: {
    id: number;
    icon: string;
    title: string;
    description: string;
    buttonTitle: string;
    [key: string]: any;
  };
  width?: string;
  height?: string;
  handleClick: (id: number, val?: any) => void;
};

const HomeProductsCard = ({
  cards: { id, title, icon, description, buttonTitle, url },
  handleClick,
  isSelected,
}: CardsProps & { isSelected: boolean }) => {
  const isComingSoon = title.includes("(Coming Soon)*");

  return (
    <CardContainer
      isSelected={isSelected}
      isComingSoon={isComingSoon}
      onClick={() => (isComingSoon ? undefined : handleClick(id, url))}
    >
      <CardHeader>
        <img src={icon} alt="Icon" />
        <CardTitle>
          {isComingSoon ? (
            <>
              {title.substring(0, title.indexOf("(Coming Soon)*"))}
              <GreenText>(Coming Soon)*</GreenText>
            </>
          ) : (
            title
          )}
        </CardTitle>
      </CardHeader>

      <CardDes>{description}</CardDes>

      <CardButtonCon>
        <CardButton isComingSoon={isComingSoon}>{buttonTitle}</CardButton>
      </CardButtonCon>
    </CardContainer>
  );
};

export default HomeProductsCard;
